import type { Client } from "@xmpp/client"
import AdHocCommands from "@/api/adHocCommands"
import { DataFormsParser } from "@/lib/formParser"
import type { CrewWrite } from "@/lib/crewBoard"

/**
 * One write to a vehicle's chat. A vehicle without a chat gets one here, with
 * its GPS device, since a new chat won't show a position without it.
 */
export const saveCrewChat = async (
  client: Client,
  { row, name, driverJid, clearDriver }: CrewWrite,
): Promise<void> => {
  if (row.chat) {
    await AdHocCommands.upsertMuc({
      client,
      mucJid: row.chat.jid,
      name,
      driverJid,
      clearDriver,
    })
    return
  }
  const response = await AdHocCommands.upsertMuc({
    client,
    name,
    driverJid,
    carId: row.car.id,
  })
  const command = response.getChild("command")
  const form = command && DataFormsParser.parse(command)
  const mucJid = form?.fields?.["muc_jid"]?.values[0]
  // Device ID is the second half of the car_id ("4:some_device").
  const device = row.car.id.split(":")[1]
  if (mucJid && device) {
    await AdHocCommands.setDriverGPSDevice(client, mucJid, device)
  }
}
